import { Injectable } from '@angular/core';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {environment} from '../../../../../environments/environment';
import {Contract} from '../../../contract/interfaces/Contract';

@Injectable()
export class ContractService {

  private route = 'contract';
  constructor(private http: AuthHttp) { }


  public getContracts(limit, page, airlineId: number) {
    const params: any = {
      limit: limit,
      page: page,
      airline_id: airlineId
    };
    return this.http.get(`${environment.baseUrl}${this.route}`, {params: params}).map(res => res.json()).toPromise();
  }

  public getContract(id) {
    return this.http.get(`${environment.baseUrl}${this.route}/${id}`).map((res) => res.json()).toPromise();
  }

  public update(Contract: Contract) {
    return this.http.put(`${environment.baseUrl}${this.route}/${Contract.id}`, Contract).toPromise();
  }


  public create(Contract: Contract) {
    return this.http.post(`${environment.baseUrl}${this.route}`, Contract).map((res) => res.json()).toPromise();
  }


  public delete(id) {
    return this.http.delete(`${environment.baseUrl}${this.route}/${id}`).map((res) => res.json()).toPromise();
  }

  public getDefaultContract() {
    return this.http.get(`${environment.baseUrl}${this.route}/default`).map((response) => response.json()).toPromise();
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/contract/services/contract/contract.service.ts